<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="title_page">The Procane Chronicle</h1>
<h2 class="center">A Philip St. Ives Mystery</h2>
<h3 class="center" style="margin-top:80px;">Ross Thomas writing as Oliver Bleeck</h3>
<p class="center"><span>A MysteriousPress.com</span></p>
<p class="center"><span>Open Road Integrated Media</span></p>
<p class="center"><span>Ebook</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 2-title_page.vue?40cb7d28